class Fetcher<T = any> {

  private path: string;
  private method: string;

  private responseText: string;
  public Result: T | null;

  constructor(path: string, method: string = "GET") {
    this.path = path;
    this.method = method;
    this.responseText = "";
    this.Result = null;
    this.init(path, method);
  }

  public init(path: string, method: string = "GET"): void {
      this.path = path;
      this.method = method;
      // Prepend base url if not explicitly given
      if (!this.path.startsWith("https://") && !this.path.startsWith("http://")) {
          this.path = window.location.origin + "/" + this.path;
      }
      console.log("fetch path: " + path);
  }

  public request(data: string | null = null, callback: ((result: T | null) => void) | null = null, signal?: AbortSignal): Promise<void> {

    let hdrs: { [name: string]: string } = {};
    if(this.method === "POST") {
      hdrs = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    return fetch(this.path, {
        method: this.method,
        headers: hdrs,
        body: data,
        signal
      })
      .then((response: Response) => response.text().then((text) => ({ response, text })))
      .then(({ response, text }: { response: Response; text: string }) => {
        this.responseText = text;
        try {
            return JSON.parse(text) as T;
        } catch {
            console.error(
                `[Fetcher] ${this.method} ${this.path} — The response is not valid JSON (HTTP ${response.status} ${response.statusText})`,
                text.slice(0, 500)
            );
            return null;
        }
      })
      .then((json: T | null) => {
        this.Result = json;
      })
      .then(() => {
        if(callback != null) {
          callback(this.Result);
        }
      })
      .catch((error: any) => {
        // Aborted by a newer request — expected, not an error.
        if(error?.name === 'AbortError') return;
        if(typeof error != 'object') {
            console.error(error);
            console.error(this.responseText);
        }

        console.error("Error loading JSON:", error.response);
        console.error("Error:", error);
        console.error("this:", this);
      });
  }
}

export default Fetcher;
